import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const usePostsQuery = createQueryHook(MembershipsCreatorApiClient.getPosts, {
  queryKey: ['posts'],
})
